/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ConfigSpec } from './configSpec';


export interface ConfigListSpec { 
    /**
     * List of config key and its value.
     */
    configs: Array<ConfigSpec>;
}

